import React from 'react';

export const ShareSvg = () => (
  <svg
    width="72px"
    height="72px"
    viewBox="0 0 72 72"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <rect
        id="share-path-1"
        x="0"
        y="0"
        width="47.9230189"
        height="33.7313208"
        rx="6.13"
      />
    </defs>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-1031, -155)">
        <g transform="translate(1031, 155)">
          <path
            d="M0,36 C0,16.1187272 16.1197409,0 36.002264,0 C55.8847871,0 72,16.1187272 72,36 C72,55.8812728 55.8802591,72 36.002264,72 C16.1242689,72 0,55.8767451 0,36"
            fill="#B2D8C6"
            fillRule="nonzero"
          />
          <g transform="translate(12.0408, 19.1366)">
            <mask id="share-mask-2" fill="white">
              <use xlinkHref="#share-path-1" />
            </mask>
            <g id="Group" mask="url(#share-mask-2)" fillRule="nonzero">
              <rect
                fill="#FEFEFE"
                x="0"
                y="0"
                width="47.9230189"
                height="33.7313208"
              />
              <polygon
                fill="#EAEAEA"
                points="0 33.7313208 23.9592453 16.8679245 47.9230189 33.7313208"
              />
              <path
                d="M47.9230189,0 L26.2550943,18.1177358 C24.9283019,19.2271698 22.994717,19.2271698 21.6679245,18.1177358 L0,0 L47.9230189,0 Z"
                fill="#DBDBDB"
              />
              <path
                d="M47.9230189,0 L25.3766038,15.8716981 C24.5298113,16.469434 23.3977358,16.469434 22.5464151,15.8716981 L0,0 L47.9230189,0 Z"
                fill="#FEFEFE"
              />
            </g>
          </g>
          <path
            d="M29.3116981,32.3683019 C28.6007547,34.2430189 29.3886792,36.3939623 31.6618868,38.7577358 C33.4324528,40.6007547 35.4067925,41.850566 35.4883019,41.9003774 L35.6875472,42.0271698 C35.7690566,42.0769811 35.8686792,42.0815094 35.954717,42.0316981 L36.1630189,41.9139623 C36.1630189,41.9139623 38.2550943,40.7230189 40.125283,38.9433962 C42.4981132,36.6837736 43.3811321,34.5690566 42.7562264,32.6626415 C42.2626415,31.1728302 41.1350943,30.2354717 39.6633962,30.0950943 C38.4,29.9728302 37.0415094,30.4845283 36.1177358,31.4309434 L36.0588679,31.4898113 L36.0045283,31.4309434 C35.189434,30.5207547 33.9849057,29.9637736 32.8075472,29.9366038 C32.7124528,29.9366038 32.6173585,29.9366038 32.5222642,29.9366038 C31.0415094,30.0135849 29.8777358,30.9011321 29.3207547,32.3683019"
            fill="#EC2031"
            fillRule="nonzero"
          />
        </g>
      </g>
    </g>
  </svg>
);
